// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7a85fcbe","495":"d5f05162","498":"e3443fe2","560":"5d3c2d2c","703":"88e801a2","787":"cda6f2bd","920":"93e77ee4"}[chunkId] + ".chunk.js";
};